export default __webpack_public_path__ + "static/media/smiley-07.291232e3.png";